import React, { useState, memo, useRef, useEffect } from "react";
import classNames from "classnames/bind";
import PropTypes from "prop-types";
import {
  FullScreenIcon,
  OffStatus,
  OnStatus,
  LoseConnectStatus,
  WeakStatus,
  DownIcons,
} from "../../../../components/Icons/Icons";
import { CameraContext } from "../../LiveCamera";
import styles from "./Header.module.css";
import { quickSort } from "../../../../utils";
import { Toast } from "../../../../components";
import { screens } from "./configScreen";
import { useTranslation } from "react-i18next";
const cx = classNames.bind(styles);

const Header = ({
  setFilter,
  filter,
}) => {
  const {
    isLoadingCamera,
    setCurrentPage,
    screen,
    setScreen,
    isFullScreen,
    setIsFullScreen,
    showTaskbar,
    setShowTaskBar,
    oneThread, setOnThread,
    isGroup,
    setGroupCode,
    isSearchCam,
    setIsSearchCam,
    screenSearch
  } = React.useContext(CameraContext);
  const [listNumber, setListNumber] = useState(screens);
  const [showFilter, setShowFilter] = useState(false);
  const ref = useRef();
  const refStatus = useRef();
  const filterStatus = useRef();
  const refBtn = useRef();
  const [col, setCol] = useState(1);
  const [row, setRow] = useState(1);
  const [isShowForm, setIsShowForm] = useState(false);
  const companyCode = sessionStorage.getItem('company_code');
  const { t } = useTranslation();
  const handleFullScreen = () => {
    setIsFullScreen(!isFullScreen);
    sessionStorage.setItem("fullScreen", !isFullScreen);
    if (isSearchCam) {
      setIsSearchCam(false)
    }
  };
  const changeScreen = (index) => {
    if (!isLoadingCamera) {
      setScreen(index);
      setCurrentPage(1);
      sessionStorage.setItem("col", index.col)
      sessionStorage.setItem("row", index.row)
      sessionStorage.setItem("total", index.total)
    }
  };
  const handleChangeScreen = () => {
    if (col >= 1 && row >= 1) {
      setScreen({
        col: Number(col),
        row: Number(row),
        total: Number(col) * Number(row),
      });
      const newData = quickSort([
        ...listNumber,
        {
          col: Number(col),
          row: Number(row),
          total: Number(col) * Number(row),
        },
      ]);

      setListNumber(newData);
      setIsShowForm(!isShowForm);
    }
    else {
      Toast.open(t("stream.customScreenError"), "danger")
    }
  };
  React.useEffect(() => {
    let handler = (e) => {
      if (!ref?.current?.contains(e.target) && e.target !== refBtn?.current) {
        setIsShowForm(false);
      }
    };

    document.addEventListener("click", handler);

    return () => {
      document.removeEventListener("click", handler);
    };
  }, []);
  React.useEffect(() => {
    let handler = (e) => {
      if (
        !filterStatus?.current?.contains(e.target) &&
        !refStatus?.current?.contains(e.target)
      ) {
        setShowFilter(false);
      }
    };

    document.addEventListener("click", handler);

    return () => {
      document.removeEventListener("click", handler);
    };
  }, []);

  useEffect(() => {
    if (isGroup) {
      setOnThread(true)
      setCurrentPage(1)
    } else {
      setOnThread(false)

      setCurrentPage(1)
    }
  }, [isGroup, setGroupCode, setCurrentPage, setOnThread])

  return (
    <div
      className={cx("content", isFullScreen ? "full" : "")}
      style={
        isFullScreen
          ? showTaskbar
            ? {}
            : {
              display: "none",
            }
          : {}
      }
    >
      {!isFullScreen && (
        <div className={cx("left")}>
          <h2 className={cx("title")}>{t("stream.stream")}</h2>
          <button
            ref={refStatus}
            onClick={() => setShowFilter(!showFilter)}
            style={
              showFilter ? { backgroundColor: "#0040FF", color: "#fff" } : {}
            }
            className={cx("btn")}
          >
            <span>{t("stream.status")}</span>
            <span
              style={{
                marginTop: 5,
                position: "relative",
                top: 5,
                paddingLeft: 6,
              }}
            >
              <DownIcons color={showFilter ? "white" : "black"} />
            </span>
          </button>
          {showFilter && (
            <div ref={filterStatus} className={cx("filter")}>
              <div className={cx("form-tick")}>
                <input
                  onChange={(e) => setFilter(e.target.checked, "on")}
                  checked={filter.on}
                  className={cx("tick")}
                  type="checkbox"
                />
                <span className={cx("icon_status")}>
                  <OnStatus />
                </span>
                <label style={{ display: "block" }}>{t("stream.online")}</label>
              </div>
              {companyCode === 'DEFAULT' && (
                <div className={cx("form-tick")}>
                  <input
                    onChange={(e) => setFilter(e.target.checked, "weak")}
                    checked={filter.weak}
                    className={cx("tick")}
                    type="checkbox"
                  />
                  <span className={cx("icon_status")}>
                    <WeakStatus />
                  </span>
                  <label>{t("stream.lostConect")}</label>
                </div>
              )}
              <div className={cx("form-tick")}>
                <input
                  onChange={(e) => setFilter(e.target.checked, "off")}
                  checked={filter.off}
                  className={cx("tick")}
                  type="checkbox"
                />
                <span className={cx("icon_status")}>
                  <OffStatus />
                </span>
                <label>{t("stream.ready")}</label>
              </div>
            </div>
          )}
        </div>
      )}
      <div className={cx("right")}>
        {!isSearchCam && (
          <div className={cx("custom")}>
            <span
              style={
                isFullScreen
                  ? {
                    color: "white",
                  }
                  : {}
              }
              className={cx("text")}
            >
              {t("stream.screenShow")}
            </span>
            {listNumber &&
              listNumber.map((item, index) => (
                <span
                  key={index}
                  onClick={(e) => changeScreen(item)}
                  className={cx(
                    "number",
                    isSearchCam ? ((screenSearch.total === item.total) ? "active" : "") :
                      ((screen.total === item.total && screen.col === item.col && screen.row === item.row) ? "active" : ""),
                    `sc-${item?.total}`
                  )}
                >
                  {item.total}
                </span>
              ))}
            <span
              onClick={(e) => setIsShowForm(!isShowForm)}
              className={cx("number")}
              ref={refBtn}
            >
              {t("stream.other")}
            </span>
            {isShowForm && (
              <div
                ref={ref}
                className={cx(isFullScreen ? "form_full" : "form")}
                style={{ position: "absolute" }}
              >
                <div className={cx("form-group")}>
                  <label> {t("stream.col")}</label>
                  <input
                    className={cx("input")}
                    onChange={(e) => setCol(e.target.value)}
                    type="number"
                    value={col}
                    min={1}

                  />
                </div>
                <div className={cx("form-group")}>
                  <label>{t("stream.row")}</label>
                  <input
                    className={cx("input")}
                    onChange={(e) => setRow(e.target.value)}
                    type="number"
                    value={row}
                    min={1}
                  />
                </div>
                <button onClick={handleChangeScreen} className={cx("access")}>
                  {t("stream.acceptCustom")}
                </button>
                <button
                  onClick={(e) => setIsShowForm(!isShowForm)}
                  className={cx("cancel")}
                >
                  {t("stream.cancelCustom")}
                </button>
              </div>
            )}
          </div>
        )}
        <div className={cx("full-screen")}>
          <span
            style={
              isFullScreen
                ? {
                  color: "white",
                }
                : {}
            }
            className={cx("text")}
          >
            {isFullScreen ? t("stream.minisizeScreen") : t("stream.fullScreen")}
          </span>
          <span onClick={handleFullScreen} className={cx("icon")}>
            {isFullScreen ? (
              <FullScreenIcon color="white" />
            ) : (
              <FullScreenIcon color="black" />
            )}
          </span>
        </div>
      </div>
    </div>
  );
};


export default memo(Header);
